export const Actions = {
  LIST_TERRITORIES: "LIST_TERRITORIES",
  LIST_TERRITORIES_SUCCEEDED: "LIST_TERRITORIES_SUCCEEDED",
};
